<template>
	<div class="main">
		<div class="top">
			<img class="top_img" src="../assets/class/bg_head2.png"/>
			<!-- <div class="top_right"> -->
				<!-- <div  v-for="(item,index) in topList" :key="item.id">
					<div class="top_right_div" v-if="index<=2">
						<img class="top_right_img" src="../assets/class/first.png" v-if="index == 0"/>
						<img class="top_right_img" src="../assets/class/second.png" v-if="index == 1"/>
						<img class="top_right_img" src="../assets/class/thrid.png" v-if="index == 2"/>
						<div class="top_right_text">{{ item.subjectName }}</div>
					</div>
				</div> -->
				<!-- <div class="top_right_div">
					<img class="top_right_img" src="../assets/class/second.png"/>
					聚焦财经政法融通育人推进继...
				</div>
				<div class="top_right_div">
					<img class="top_right_img" src="../assets/class/thrid.png"/>
					聚焦教育新征程
				</div> -->
			<!-- </div> -->
		</div>
		<div class="search_con">
			<div class="search_con_top">
				<div class="search_con_top_left" ref="firContent">
					<div class="search_left_title">分类：</div>
					<div class="search_left_con"	:style="{ 'height': firMore ? textHeight : 'auto' }">
						<div :class="kcflIndex == '' ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(1,'','')">全部</div>
						<div v-for="(item,key) in kcflList" :key="key">
							<div :class="kcflIndex == item.id ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(1,key,item)">{{item.subName}}</div>
						</div>
					</div>
					<div class="search_more" v-if="isShowFirMore" @click="firMore = !firMore">更多<i :class="firMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
					<div class="search">
						<el-input
							class="search_input"
						placeholder="请输入要搜索的内容"
						v-model="input"
							size="small"
						clearable
						style="width: 90%;">
						</el-input>
						<div class="search_btn" @click="gosearch">
							搜索
						</div>
					</div>
				</div>
			</div>
			<div class="search_con_down_left" ref="subContent" v-if="smallFL.length>0">
				<div class="search_left_title">子类：</div>
				<div class="search_left_con"	:style="{ 'height': subMore ? textHeight : 'auto' }">
					<div :class="smallIndex == '' ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(2,'','')">全部</div>
					<div v-for="(item,key) in smallFL" :key="key">
						<div :class="smallIndex == item.id ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(2,key,item)">{{item.subName}}</div>
					</div>
				</div>
				<div class="search_more" v-if="isShowSubMore" @click="subMore = !subMore">更多<i :class="subMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i></div>
			</div>
		</div>
		<div class="content_con">
			<div class="con_body">
				<div class="con_body_div">
					<div v-for="(kecheng,kcKey) in classList" :key="kcKey">
						<div class="item_div" @click="goDetail(kecheng)">
							<div class="item_top">
								<img class="item_img" :src="kecheng.imgUrl" />
							</div>
							<div class="item_title">
								{{kecheng.subName}}
							</div>
							<div class="item_down">
								<div>
									学时：{{kecheng.creditHour}}
									<!-- <span class="item_down_span">
										学时：{{kecheng.learnTime}}
									</span> -->
								</div>
								<div>
									浏览次数：{{kecheng.previewNum}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pageCon">
					<el-pagination
						background
						class="mt-4"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pageNo"
						:page-sizes="[12, 24, 32, 40]"
						:page-size="pageSize"
						layout=" prev, pager, next, sizes, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Loading } from 'element-ui';
import { Message } from 'element-ui';
	export default{
		data() {
			return {
				loading: false,
				loadingText: '加载中',
				kcflList:[],//课程分类
				smallFL:[],//分类下的分类
				id:'',
				classList: [],//课程列表
				hasLogin:false,
				userInfo:'',
				pageNo:1,
				pageSize:12,
				total:0,
				input: '',
				
				kcflIndex: '',
				smallIndex: '',
				textHeight: null,  // 框中内容的高度
				isShowFirMore: false,  // 控制展开更多的显示与隐藏
				firMore: false,  // 内容状态是否打开
				isShowSubMore: false,  // 控制展开更多的显示与隐藏
				subMore: false,  // 内容状态是否打开
				topList:[]
			}
		},
		created() {
			this.getKCFL();
			this.getTopten()
			// this.getClassList();
		},
		mounted() {
			this.$nextTick(() => {
				// 这里具体行数可依据需求自定义
				let lineHeight = 0.274 * document.documentElement.style.fontSize.replace('px','');
				this.textHeight = `0.274rem`
				setTimeout(()=>{
					if (this.$refs.firContent.offsetHeight > lineHeight) {
						this.isShowFirMore = true
						this.firMore = true
					} else {
						this.isShowFirMore = false
						this.firMore = false
					}
					if (this.$refs.subContent && this.$refs.subContent.offsetHeight > lineHeight) {
						this.isShowSubMore = true
						this.subMore = true
					} else {
						this.isShowSubMore = false
						this.subMore = false
					}
				},200)
			})
		},
		methods:{
			chooseIndex(index,key,obj){
				if(!obj){
					if(index == 1){
						this.kcflIndex = ''
						this.smallFL = []
					}else{
						this.smallIndex = '';
					}
					this.getClassList();
					return
				}else{
					if(index == 1){
						if(obj){
							this.kcflIndex = obj.id
							this.smallFL = [...this.kcflList[key].children]
							this.smallIndex = '';
						}else{
							this.kcflIndex = ''
							this.smallIndex = '';
						}
					}
					if(index == 2){
						if(obj){
							this.smallIndex = obj.id
						}else{
							this.smallIndex = ''
						}
					}
				}
				this.getClassList();
			},
			//查询课堂分类
			getKCFL(){
				this.$get('/blade-web/learn-subject/tree',{})
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.kcflList = res.data;
						this.getClassList();
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
				
			},
			//查询排行
			getTopten(){
				this.$get('/blade-web/learn-subject/top-ten',{})
				.then((res) => {
					if(res.code == '200'){
						this.topList = res.data	
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
				
			},
			//查询专题列表
			getClassList(){
				this.$get('/blade-web/learn-subject/get-subject-info-page',{
					subName: this.input,
					parentId:this.kcflIndex,
					childId: this.smallIndex,
					current:this.pageNo,
					size:this.pageSize,
				})
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.classList = res.data.records;
						for (let i = 0; i < this.classList.length; i++) {
							let img = JSON.parse(this.classList[i].coverUrl)[0].url;
							this.classList[i].imgUrl = img;
						}
						this.total = res.data.total;
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			//进入详情
			goDetail(obj){
				let routeUrl = this.$router.resolve({
					 path:'/videoDetail/videoDetail',
					 query:{
						id: obj.subInfoId,
						type: '1',//1 专题  2 课程
					 }
				 });
				window.open(routeUrl.href, '_blank');
				
				//获取登录用户信息
				// this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
				// if(this.userInfo != null && this.userInfo != undefined){
				// 	this.hasLogin = true;
				// }
				// if(this.hasLogin){
					// if(obj.isFree == '0' && obj.isOrder == '0'){
					// 	// this.$confirm('是否使用'+obj.integral +'云豆观看内容', '提示', {
					// 	//   confirmButtonText: '确定',
					// 	//   cancelButtonText: '取消',
					// 	//   type: 'warning'
					// 	// }).then(() => {
						  
					// 	// }).catch(() => {
						   
					// 	// });
					// }else{
					// 	let routeUrl = this.$router.resolve({
					// 	     path:'/videoDetail/videoDetail',
					// 	     query:{
					// 	     	id: obj.subInfoId,
					// 	     	type: '1',//1 专题  2 课程
					// 	     }
					// 	   });
					// 	window.open(routeUrl.href, '_blank');
					// }
				// }else{
				// 	//登录
				// 	this.$message({
				// 	  message: '请先登录',
				// 	  type:'error'
				// 	});
				// }
			},
			handleCurrentChange(val) {
			  this.pageNo = val;
			  this.getClassList();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getClassList();
			},
			gosearch(){
				this.pageNo = 1;
				this.getClassList();
			}
		}
	}
</script>

<style scoped>
	.main {
		background-color: #F0F6F9;padding-bottom: 0.4rem;
	}
	.top{
		width: 100%;height: 2.4rem;position: relative;
	}
	.top_img{
		width: 100%;height: 2.4rem;
	}
	.top_right{
		width: 3.46rem;height: 100%;background: rgba(0, 21, 45, 0.4);position: absolute;right: 1.2rem;top: 0;
	}
	.top_right_div{
		width: 2.80rem;
		color: #ffffff;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 700;height: 0.8rem;display: flex;align-items: center;
		white-space: nowrap;       /* 不换行 */
		overflow: hidden;          /* 隐藏溢出部分 */
		text-overflow: ellipsis;   /* 超出部分显示省略号 */
	}
	.top_right_img{
		width: 0.29rem;height: 0.4rem;margin-right: 0.08rem;margin-left: 0.51rem;
		position: relative;
		top: 0.05rem;
	}
	.top_right_text{
		display: inline-block;
		width: calc(100% - 0.88rem);
		height: 0.8rem;
		line-height: 0.8rem;
		white-space: nowrap;       /* 不换行 */
		overflow: hidden;          /* 隐藏溢出部分 */
		text-overflow: ellipsis;   /* 超出部分显示省略号 */
	}
	.search_con{
		width: 12rem;background: #ffffff;padding: 0.5rem 0;margin: 0.4rem auto;box-shadow: 0 0 0.14rem 0 #134f9721;border-radius: 0.06rem;
	}
	.search_con_top{
		display: flex;justify-content: space-between;margin-left: 0.3rem;
	}
	.search_con_top_left{
		display: flex;white-space: nowrap;
	}
	.search_left_title{
		color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 700;padding-top: 0.04rem;
	}
	.search_left_active{
		padding: 0.04rem 0.08rem;border-radius: 4px;background: #134f971a;color: #134F97;font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;font-weight: 400;margin-left: 0.2rem;cursor: pointer;
	}
	.search_left_normal{
		padding: 0.04rem 0.08rem;font-size: 0.14rem;font-family: Alibaba PuHuiTi;font-weight: 400;color: #000000;margin-left: 0.2rem;cursor: pointer;
	}
	.search_left_con{
		width: 7.14rem;display: flex;flex-wrap: wrap;row-gap: 0.2rem;overflow: hidden;
	}
	.search_con_down_left{
		display: flex;white-space: nowrap;margin-left: 0.3rem;margin-top: 0.2rem;align-items: flex-start;
		overflow: hidden;
	}
	.search_more{
		color: #134f97;font-family: Alibaba PuHuiTi;font-size: 0.14rem;margin-left: 0.05rem;cursor: pointer;margin-top: 0.05rem;
	}
	.search{
		display: flex;margin-right: 0.3rem;margin-left: 0.5rem;
	}
	.search_input{
		width:3.45rem;height:0.33rem;line-height: 0.33rem;background: #EEEEEE;
	}
	.search_input>>>.el-input__inner{
		height: 0.33rem !important;
	}
	.search_btn{
		width: 0.76rem;height: 0.33rem;border-radius: 0.04rem;background: #FCC106;color: #ffffff;font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;font-weight: 400;display: flex;align-items: center;justify-content: center;
		margin-left: 0.08rem;cursor: pointer;
	}
	.content_con{
		background-color: #F0F6F9;display: flex;justify-content: center;
	}
	.con_body{
		width:12.3rem;
	}
	.con_body_div{
		display: flex;flex-wrap: wrap;height: 8.53rem;overflow-y: auto;align-content: flex-start;
	}
	.marginR30{
		margin-right: 0.3rem;
	}
	.item_div{
		width: 2.77rem;height: 2.5rem;margin-bottom: 0.3rem;cursor: pointer;border-radius: 0.06rem;background: #ffffff;box-shadow: 0 0 0.14rem 0 #134f9721;margin:0.15rem;
	}
	.item_top{
		width: 2.77rem;height: 1.56rem;margin-bottom: 0.08rem;border-radius: 0.06rem 0.06rem 0 0;
	}
	.item_img{
		width: 2.77rem;height: 1.56rem;border-radius: 0.06rem 0.06rem 0 0;
	}
	.item_title{
		color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.18rem;
		height: 0.45rem;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		-webkit-line-clamp: 2;
		padding: 0 0.1rem;
		margin-bottom: 0.08rem;
	}
	.item_down{
		width: 2.42rem;display: flex;align-items: center;justify-content: space-between;padding: 0 0.1rem;
		color: #cccccc;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 400;
	}
	.item_down_span{
		margin-left: 0.25rem;
	}
	.pageCon{
		display: flex;justify-content: flex-end;margin-top: 0.3rem;font-size: 0.14rem;
	}
</style>



// WEBPACK FOOTER //
// src/index/classList.vue